import { routeInfo } from '../../../../routeInfo';
import * as React from 'react';
import { ConnectedProps, Provider, connect } from 'react-redux';
import * as _ from 'lodash';
import { Container, Draggable } from 'react-smooth-dnd';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import RenameScriptForm from '../RenameScriptForm/RenameScriptForm';
import DuplicateScriptForm from '../DuplicateScriptForm/DuplicateScriptForm';
import NewTransformForm from '../NewTransformForm/NewTransformForm';
import * as actions from '../../../../redux/projects/actions.projects';
import history from '../../../../history';
import ReactTooltip from 'react-tooltip';
import projectHelper from '../../../../services/ProjectHelper';
import applyDrag from '../../../../services/mini/applyDrag';
import getArrayHash from '../../../../services/mini/getArrayHash';
import listenChangesInScripts from '../../../../hoc/listenChangesInScripts';
import capitalize from '../../../../services/mini/capitalize';
import { Environment } from '../../../../const/environment';
import { ScriptsDropZone } from '../ScriptsDropZone/ScriptsDropZone';
import getProjectId from '../../../../services/mini/getProjectId';
import ScriptItem from '../ScriptItem/ScriptItem';
import createNewScriptHelper from '../../../../services/actionHelpers/createNewScriptHelper';
import downloadScriptsHelper from '../../../../services/actionHelpers/downloadScriptsHelper';
import device from '../../../../services/mini/device';
import getScriptByScriptName from '../../../../services/mini/getScriptByScriptName';
import ProjectLeftPanel from '../../../components/ProjectLeftPanel/ProjectLeftPanel';
import ProjectLeftPanelTitle from '../../../components/ProjectLeftPanel/ProjectLeftPanelTitle';
import ProjectLeftPanelList from '../../../components/ProjectLeftPanel/ProjectLeftPanelList';
import ProjectLeftPanelAddBtn from '../../../components/ProjectLeftPanel/ProjectLeftPanelAddBtn';
import ProjectLeftPanelBottomPanel from '../../../components/ProjectLeftPanel/ProjectLeftPanelBottomPanel';
import ProjectLeftPanelListItem from '../../../components/ProjectLeftPanel/ProjectLeftPanelListItem';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import GitHubRepoPanel from '../GitHubIntegration/GitHubRepoPanel/GitHubRepoPanel';
import { SCRIPT_EDITOR } from '../../../../const/editorNames';
import menuItems from '../../../../const/menuItems';
import { IScript } from '../../../../models/IScript';
import { IStore } from '../../../../redux/initialState';
import ProjectLeftPanelCollapsible from '../../../components/ProjectLeftPanel/ProjectLeftPanelCollapsible';
import { getScriptTypeLabel } from '../../../../services/mini/getScriptTypeLabel';
import { getEmptyTransformText, getTransformText, removeEmptyRowsFromTransform } from '../TransformMode/getTransformText';
import { ITransform, ITransformRow } from '../../../../models/ITransform';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import HistoryKeeper from '../../../../services/HistoryKeeper';
import ToasterService from '../../../../services/ToasterService';
import GitHubIntegrationWrapper from '../../../components/GitHubIntegrationWrapper/GitHubIntegrationWrapper';
import SaveScriptsButton from '../SaveScriptsButton/SaveScriptsButton';
import { Suspense } from 'react';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import store from '../../../../store';
import ScriptGraphPopup from '../ScriptGraphPopup/ScriptGraphPopup';
import { ISetScriptsGraphCacheParam } from '../../../../redux/projects/actions.projects';

type ScriptsPanelProps = PropsFromRedux & {
    environment: Environment;
    canImportScripts: boolean;
    canExportScripts: boolean;
    searchTerm: string;
    transformMode: boolean;
    onCloseSearch: () => void;
};

type ScriptsPanelState = {
    scripts: IScript[],
    exportInProgress: boolean
    scriptsPanelCollapsed: boolean
    transformsPanelCollapsed: boolean
    hasUnsavedChanges: boolean
}


const LS_PANEL_SCRIPTS_COLLAPSER_KEY = 'scripts-panel-collapsed';
const LS_PANEL_TRANSFORM_COLLAPSER_KEY = 'transform-panel-collapsed';


class ScriptsPanel extends React.Component<ScriptsPanelProps, ScriptsPanelState> {

    downloadScriptsPreventMissClicks: () => void;

    constructor(props) {
        super(props);

        const { project, transformsAvailable } = this.props;

        this.state = {
            scripts: (project && project.scripts) ? project.scripts : [],
            exportInProgress: false,
            hasUnsavedChanges: false,
            scriptsPanelCollapsed: transformsAvailable ? (isLocalStorageAvailable() ? !!localStorage.getItem(this.getPanelLsKey(LS_PANEL_SCRIPTS_COLLAPSER_KEY)) : false) : undefined,
            transformsPanelCollapsed: transformsAvailable ? (isLocalStorageAvailable() ? !!localStorage.getItem(this.getPanelLsKey(LS_PANEL_TRANSFORM_COLLAPSER_KEY)) : false) : undefined,
        };

        this.downloadScriptsPreventMissClicks = _.debounce(this.downloadScripts, 500);
    }

    componentDidMount() {
        this.checkForUnsavedChanges();
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
        this.checkForUnsavedChanges();
    }

    async checkForUnsavedChanges() {
        const hasChanges = await projectHelper.hasUnsavedChanges(this.props.project);
        if (this.state.hasUnsavedChanges !== hasChanges) {
            this.setState({ hasUnsavedChanges: hasChanges });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.project) {
            this.setState({
                scripts: nextProps.project.scripts || [],
            });
        }
    }

    goToScript = (script: IScript, projectName) => {
        const path = routeInfo.projectScripts.url(projectName, script.name);
        HistoryKeeper.setLastSelectedScript(path, projectName);
        history.push(path);
    }

    goToTransform = (script: IScript, projectName) => {
        history.push(routeInfo.projectScripts.url(projectName, script.name));
    }

    finishDrop = (scripts, transforms) => {
        const {
            project,
            environment,
            selectedStageTagId,
            selectedProdTagId
        } = this.props;
        const tagId = environment ? selectedStageTagId : selectedProdTagId;
        const finalItems = [...scripts, ...transforms];

        this.setState({ scripts: finalItems });
        this.props.reorderScripts(
            {
                projectId: project.projectId,
                tagId: tagId,
                scripts: finalItems
            });
    }

    onDropScripts = ({ addedIndex, removedIndex }) => {
        const { scripts: allScripts } = this.state;
        const scripts = allScripts.filter(s => s.type !== 'transform');
        const transforms = allScripts.filter(s => s.type === 'transform');
        const newScripts = applyDrag(scripts, addedIndex, removedIndex);

        const oldScriptIds = getArrayHash(scripts, ['name']);
        const newScriptIds = getArrayHash(newScripts, ['name']);

        if (oldScriptIds !== newScriptIds) {
            this.finishDrop(newScripts, transforms);
        }
    }

    onDropTransforms = ({ addedIndex, removedIndex }) => {
        const { scripts: allScripts } = this.state;
        const scripts = allScripts.filter(s => s.type !== 'transform');
        const transforms = allScripts.filter(s => s.type === 'transform');
        const newTransforms = applyDrag(transforms, addedIndex, removedIndex);

        const oldScriptIds = getArrayHash(transforms, ['name']);
        const newScriptIds = getArrayHash(newTransforms, ['name']);

        if (oldScriptIds !== newScriptIds) {
            this.finishDrop(scripts, newTransforms);
        }
    }

    addScript = () => {
        const { project, createScript } = this.props;
        createNewScriptHelper(project, createScript);
    }

    addTransform = () => {
        const { project, createScript } = this.props;
        confirmAlert({
            customUI: ({ onClose: onClose1 }) => {
                return <NewTransformForm
                    addNewTransform={({ transformName }) => {
                        createScript({
                            projectId: project.projectId,
                            tagId: project.stageTagId,
                            scripts: [{ title: transformName, body: getEmptyTransformText() }],
                            scriptType: 'transform'
                        });
                    }}
                    project={project}
                    onClose={onClose1}
                />;
            }
        });
    }

    renameScript = (script: IScript, isCurrent) => {
        const { project, renameScript, transformsAvailable } = this.props;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <RenameScriptForm
                        project={project}
                        isCurrent={isCurrent}
                        transformsAvailable={transformsAvailable}
                        script={script}
                        scriptName={script.name}
                        scriptId={script.scriptId}
                        renameScript={renameScript}
                        onClose={onClose} />
                );
            }
        });
    }

    duplicateScript = (script: IScript) => {
        const { project, duplicateScript, transformsAvailable } = this.props;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <DuplicateScriptForm
                        project={project}
                        transformsAvailable={transformsAvailable}
                        script={script}
                        scriptName={script.name}
                        scriptId={script.scriptId}
                        duplicateScript={duplicateScript}
                        onClose={onClose} />
                );
            }
        });
    }

    exportScript = (script: IScript, isCurrent) => {
        const { exportScript } = this.props;

        exportScript({ script });
    }

    deleteScript = (script: IScript, isCurrent) => {
        const { projectId, project, deleteScript } = this.props;
        const scriptId = script.scriptId;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Delete"
                        okBtnCb={() => {
                            const { scripts } = this.state;
                            const deletedScript = _.find(scripts, { scriptId });
                            deletedScript.deleting = true;
                            this.setState({ scripts }, () => {
                                deleteScript({ project, scriptId, isCurrent });
                                onClose();
                            });
                        }}
                        type="delete"
                        title={`Delete ${getScriptTypeLabel(script)}`}
                        message={<div>Are you sure you want to delete <b>{script.name}</b> {getScriptTypeLabel(script).toLowerCase()}?</div>}
                    />
                );
            }
        });
    }

    openScriptDiagram = (script: IScript) => {
        const {
            environment,
            project,
            email
        } = this.props;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Provider store={store}>
                        <Suspense fallback={<Loader theme={LoaderTheme.Light} size={LoaderSize.Big} center={true} />}>
                            <ScriptGraphPopup
                                projectId={project.projectId}
                                environment={environment}
                                script={script}
                                onClose={() => {
                                    onClose();
                                }}
                            />
                        </Suspense>
                    </Provider>
                );
            }
        });
    }

    discardScriptChanges = (script: IScript) => {
        const { discardScriptChanges } = this.props;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Discard"
                        okBtnCb={() => {
                            onClose();
                            discardScriptChanges({ script });
                        }}
                        title="Discard Local Changes"
                        message={<div>Are you sure you want to discard your current changes in <b>{script.name}</b> {getScriptTypeLabel(script).toLowerCase()}?</div>}
                    />
                );
            }
        });
    }

    downloadScripts = () => {
        const {
            project,
            environment
        } = this.props;
        this.setState({ exportInProgress: true }, async () => {
            try {
                await downloadScriptsHelper(project, environment);
                this.resetScriptsDownloading();
            } catch (e) {
                this.setState({ exportInProgress: false });
            }
        });
    }

    resetScriptsDownloading = () => {
        setTimeout(() => {
            this.setState({ exportInProgress: false });
        }, 8000);
    }

    onVersionHolderClick = () => {
        window.debugInfo.dialogId = window.tutorProject?._dialogId;
        const keys = Object.keys(window.debugInfo);
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Ok"
                        hideCancelBtn={true}
                        okBtnCb={() => {
                            onClose();
                        }}
                        title="Info"
                        message={<div className="secret-debug-info">{keys.map((key) => {
                            return <div key={key}><b>{key}</b>:
                                <span dangerouslySetInnerHTML={{ __html: window.debugInfo[key] }} />
                            </div>;
                        })}</div>} />
                );
            }
        });
    }

    stopPropagation(e) {
        e.stopPropagation();
    }
    getPanelLsKey = (panelKey) => {
        const { project } = this.props;
        return `${panelKey}-${project.projectId}`;
    }
    savePanelState = (panelKey, value) => {
        if (isLocalStorageAvailable()) {
            if (value) {
                localStorage.setItem(this.getPanelLsKey(panelKey), value);
            } else {
                localStorage.removeItem(this.getPanelLsKey(panelKey));
            }
        }
    }

    resetSearch = () => {
        this.props.onCloseSearch();
    }

    render() {
        const {
            project,
            scriptName,
            transformMode,
            environment,
            canImportScripts,
            canExportScripts,
            importFiles,
            importConflictScripts,
            searchTerm,
            lastSearchUpdate,
            codeString,
            githubDeployId,
            transformsAvailable,
            statsScriptsSearch,
        } = this.props;

        const {
            scripts: allScripts,
            exportInProgress,
            scriptsPanelCollapsed,
            transformsPanelCollapsed,
            hasUnsavedChanges
        } = this.state;

        const scripts = allScripts.filter(s => s.type !== 'transform').filter(s => {
            if (searchTerm?.length > 0) {
                return statsScriptsSearch?.[s.name]?.count > 0;
            }
            return true;
        });

        const scriptsCount = allScripts.filter(s => s.type !== 'transform')?.length;
        const areScriptsFiltered = scripts?.length !== scriptsCount;

        const transforms = allScripts.filter(s => s.type === 'transform');

        const isMobile = device.isMobile();


        const isLastTag = projectHelper.isLastTag(project, this.props[`selected${capitalize(environment)}TagId`]);

        const draggable = (isLastTag && environment && device.isDesktop());

        const scriptsEl = <Container
            dragClass="drag-ghost"
            dropClass="drop-ghost"
            onDrop={this.onDropScripts}
            lockAxis="y">
            {searchTerm?.length > 0 && scripts?.length === 0 && <div className="scripts-panel_no-scripts-found">No matches found in the scripts</div>}
            {scripts.map((script, index) => {
                const scriptItemEl = <ProjectLeftPanelListItem
                    key={script.scriptId}
                    selected={script.name === scriptName && !transformMode}>
                    <ScriptItem
                        script={script}
                        project={project}
                        selectedScriptName={scriptName}
                        deleting={script.deleting}
                        isLastTag={isLastTag}
                        environment={environment}
                        draggable={draggable}
                        isActive={script.name === scriptName}
                        codeString={codeString}
                        searchTerm={searchTerm}
                        githubDeployId={githubDeployId}
                        count={statsScriptsSearch?.[script.name]?.count}
                        isLargeFile={statsScriptsSearch?.[script.name]?.isLargeFile}
                        menuOffset={index > 8 ? -70 : 0}
                        lastSearchUpdate={lastSearchUpdate}
                        onRename={this.renameScript}
                        onDuplicate={this.duplicateScript}
                        onDelete={this.deleteScript}
                        onExport={this.exportScript}
                        onDiscard={this.discardScriptChanges}
                        onOpenScriptDiagram={this.openScriptDiagram}
                        onClick={this.goToScript}
                    />
                </ProjectLeftPanelListItem>;
                if (draggable) {
                    return <Draggable key={script.scriptId}>
                        {scriptItemEl}
                    </Draggable>;
                }
                return scriptItemEl;
            })}
        </Container>;

        const scriptsAddBtn = <ProjectLeftPanelAddBtn
            display={!(!isLastTag || environment !== Environment.Staging)}
            title="Add"
            onClick={this.addScript} />;

        const transformPanelMinimized = transforms?.length === 0 || transformsPanelCollapsed;
        const scriptsPanelMinimized = scriptsPanelCollapsed;
        const bothPanelsMinimized = transformPanelMinimized && scriptsPanelMinimized;

        const scriptsHint = `${scripts.length} out of ${scriptsCount} scripts are displayed. Click here to view all.`;

        const scriptsTitle = <div onClick={this.resetSearch} className='scripts-panel__filter-icon'>
            Scripts&nbsp;{areScriptsFiltered && <i title={scriptsHint} className="icon icon-alan-filter"></i>}
        </div>;

        return (
            <div className={`scripts-panel`}>
                <ProjectLeftPanel hasData={project && project.projectId && project.hasScriptsData}>


                    {!transformsAvailable ?
                        <>
                            <ProjectLeftPanelTitle
                                title={scriptsTitle}
                                addBtn={scriptsAddBtn} />
                            <ProjectLeftPanelList>
                                {scriptsEl}
                            </ProjectLeftPanelList>
                        </> :
                        <div className='scripts-panel__main-wrapper'>
                            <div className={`scripts-panel__inner-panel ${transformPanelMinimized && 'transforms-minimized'} ${scriptsPanelMinimized && 'scripts-minimized'} ${bothPanelsMinimized && 'both-collapsed'}`}>
                                <ProjectLeftPanelCollapsible
                                    title={scriptsTitle}
                                    onCollapsedClick={() => {
                                        this.setState({ scriptsPanelCollapsed: !scriptsPanelCollapsed });
                                        this.savePanelState(LS_PANEL_SCRIPTS_COLLAPSER_KEY, !scriptsPanelCollapsed);
                                    }}
                                    collapsed={scripts?.length === 0 ? undefined : scriptsPanelCollapsed}
                                    addBtn={scriptsAddBtn}
                                    itemsCount={transforms?.length || 0}>
                                    <ProjectLeftPanelList className="scripts-panel_height-100">
                                        {scriptsEl}
                                    </ProjectLeftPanelList>
                                </ProjectLeftPanelCollapsible>
                                <ProjectLeftPanelCollapsible
                                    title="Transforms"
                                    collapsed={transforms?.length === 0 ? undefined : transformsPanelCollapsed}
                                    onCollapsedClick={() => {
                                        this.setState({ transformsPanelCollapsed: !transformsPanelCollapsed });
                                        this.savePanelState(LS_PANEL_TRANSFORM_COLLAPSER_KEY, !transformsPanelCollapsed);
                                    }}
                                    className={(transformPanelMinimized) ? 'transforms-panel_minimized' : ''}
                                    addBtn={
                                        isMobile ?
                                            <i
                                                onClick={() => {
                                                    ToasterService.showInfo({
                                                        title: 'The Alan AI Studio functionality is limited on mobile. Use Alan AI Studio within a desktop browser to work with transforms'
                                                    });
                                                }}
                                                className="icon icon-alan-info-sign icon-transforms-limited-on-mobile"></i> :
                                            <ProjectLeftPanelAddBtn
                                                display={!(!isLastTag || environment !== Environment.Staging)}
                                                title="Add"
                                                onClick={this.addTransform} />
                                    }>

                                    <ProjectLeftPanelList>
                                        <Container
                                            dragClass="drag-ghost"
                                            dropClass="drop-ghost"
                                            onDrop={this.onDropTransforms}
                                            lockAxis="y">
                                            {transforms.map((transform, index) => {
                                                const scriptItemEl = <ProjectLeftPanelListItem
                                                    disabled={isMobile}
                                                    selected={transform.name === scriptName && transformMode}
                                                    key={transform.scriptId}>
                                                    <ScriptItem
                                                        script={transform}
                                                        project={project}
                                                        selectedScriptName={scriptName}
                                                        deleting={transform.deleting}
                                                        isLastTag={isLastTag}
                                                        environment={environment}
                                                        draggable={draggable}
                                                        isActive={transform.name === scriptName}
                                                        codeString={codeString}
                                                        searchTerm={searchTerm}
                                                        githubDeployId={githubDeployId}
                                                        menuOffset={index > 8 ? -70 : 0}
                                                        lastSearchUpdate={lastSearchUpdate}
                                                        onRename={this.renameScript}
                                                        onDuplicate={this.duplicateScript}
                                                        onDelete={this.deleteScript}
                                                        onExport={this.exportScript}
                                                        onClick={this.goToTransform}
                                                        onDiscard={this.discardScriptChanges}
                                                    />
                                                </ProjectLeftPanelListItem>;

                                                if (draggable) {
                                                    return <Draggable key={transform.scriptId}>
                                                        {scriptItemEl}
                                                    </Draggable>;
                                                }
                                                return scriptItemEl;
                                            })}
                                        </Container>
                                    </ProjectLeftPanelList>


                                </ProjectLeftPanelCollapsible>
                            </div>
                        </div>}






                    <ProjectLeftPanelBottomPanel>
                        <GitHubIntegrationWrapper>
                            <GitHubRepoPanel
                                key={environment}
                                projectId={project.projectId}
                                environment={environment}
                                project={project} />
                        </GitHubIntegrationWrapper>

                        <div className={`scripts-panel_export-import-holder ${(canImportScripts && isLastTag && environment === Environment.Staging) ? 'with-import-btn' : ''}`}>
                            {canExportScripts && <div
                                className={`scripts-panel_export-scripts action-btn dark-with-blue-border middle width-100p ${exportInProgress && 'btn-loader'}`}
                                onClick={this.downloadScriptsPreventMissClicks}
                                title="Export scripts as .zip file">
                                Export
                            </div>}
                            {(canImportScripts && isLastTag && environment === Environment.Staging) &&
                                <ScriptsDropZone
                                    project={project}
                                    environment={environment}
                                    importConflictScripts={importConflictScripts}
                                    importFiles={importFiles}>
                                    <div className="scripts-panel_import-scripts-wrapper">
                                        <a className="icon icon-alan-help-sign scripts-panel__icon"
                                            onClick={this.stopPropagation}
                                            href={`${menuItems.docs.href}/usage/guides/importing-scripts/#importing-scripts`}
                                            target="_blank"
                                            rel="noreferrer"
                                            title="Drag&drop files here to add new scripts to the project or re-write existing ones" />
                                        <div className="scripts-panel_import-scripts">
                                            Import
                                        </div>
                                    </div>

                                </ScriptsDropZone>}
                        </div>

                        <SaveScriptsButton
                            key={`${hasUnsavedChanges}`}
                            environment={environment}
                            className='width-100p'
                            mode="panel" />
                    </ProjectLeftPanelBottomPanel>
                </ProjectLeftPanel>
                <div id="versionHolder" onClick={this.onVersionHolderClick} className="icon icon-alan-info-sign"></div>
            </div>
        );
    }
}


function mapStateToProps({ projectsInfo, scriptEditor, codeMetaData, gitHubIntegration, user }: IStore, ownProps) {
    const projectName = ownProps.projectName;
    const scriptName = ownProps.scriptName;

    const projectId = getProjectId(projectName, projectsInfo.projects);
    const project = projectsInfo.currentProject;
    const script = getScriptByScriptName(scriptName, project);

    return {
        transformMode: script?.type === 'transform',
        projectName: projectName,
        projectId: projectId,
        scriptName: scriptName,
        script: script,
        selectedStageTagId: project.stageTagId,
        selectedTestingTagId: project.testingTagId,
        selectedProdTagId: project.prodTagId,
        isScriptSaving: projectsInfo.currentProject.isScriptSaving,
        project: projectsInfo.currentProject,
        importConflictScripts: projectsInfo.currentProject.importConflictScripts,
        lastSearchUpdate: scriptEditor.searchPanels[SCRIPT_EDITOR]?.lastSearchUpdate,
        statsScriptsSearch: scriptEditor.searchPanels[SCRIPT_EDITOR]?.statsScriptsSearch,
        searchTerm: scriptEditor.searchPanels[SCRIPT_EDITOR]?.searchTerm,
        codeString: codeMetaData.codeString,
        githubDeployId: gitHubIntegration.githubDeployId,
        transformsAvailable: user.capabilities.transformsAvailable,
        email: user.email,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        createScript: (param) => dispatch(actions.createScript(param)),
        updateScripts: (param) => dispatch(actions.updateScripts(param)),
        reorderScripts: (param) => dispatch(actions.reorderScripts(param)),
        renameScript: (param) => dispatch(actions.renameScript(param)),
        duplicateScript: (param) => dispatch(actions.duplicateScript(param)),
        deleteScript: (param) => dispatch(actions.deleteScript(param)),
        exportScript: (param: actions.IExportScriptParam) => dispatch(actions.exportScript(param)),
        discardScriptChanges: (param) => dispatch(actions.discardScriptChanges(param)),
        importFiles: (param) => asyncDispatch(actions.importFiles, dispatch, param),
        setScriptsGraphCache: (param: ISetScriptsGraphCacheParam) => asyncDispatch(actions.setScriptsGraphCache, dispatch, param),
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(listenChangesInScripts(ScriptsPanel));
